module.exports = __webpack_public_path__ + "static/frankTheCat-bbf14a5a09b77970ef919071b142ae33.png";